import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class SettingsJemRoute extends AuthenticatedRoute {}
